import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { func, bool, shape, string } from "prop-types";
import { push } from "react-router-redux";

import { actions as recoveryPasswordActions, selectors as recoveryPasswordSelectors } from "reducers/recoveryPassword";
import { actions as loginActions } from "reducers/login";
import MainContainer from "pages/_components/MainContainer";
import Step3Content from "pages/recoveryPassword/_components/Step3Content";
import Head from "pages/_components/Head";
import withExchangeToken from "pages/_components/withExchangeToken";
import I18n from "pages/_components/I18n";
import GridLayoutExternal from "pages/_layouts/GridLayoutExternal";
import Logo from "pages/login/_components/Logo";
import Container from "pages/_components/Container";
import { Col } from "react-bootstrap";

class RecoveryUserpassStep3 extends Component {
    componentDidMount() {
        const { dispatch, exchangeToken } = this.props;
        if (!exchangeToken) {
            dispatch(push("/"));
        }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(recoveryPasswordActions.recoveryPassCleanUp());
    }

    onHeaderClose = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
    };

    renderTitleMobile = () => (
        <div className="w-min-content">
            <Logo className="svg-image logo logo-mobile-size" logoColor />
        </div>
    );

    render() {
        const { isDesktop, isRecoveringUserpass, propsGrid } = this.props;

        return (
            <GridLayoutExternal scopeToShow="recoveryPassword" isDesktop={isDesktop} {...propsGrid}>
                <div className="admin-detail-head px-0">
                    <Container>
                        <Col xs="12" className={isDesktop ? "px-0" : ""}>
                            <Head
                                onClose={this.onHeaderClose}
                                title={isDesktop ? "recoveryUserpass.step3.header" : null}
                                headerClassName={
                                    !isDesktop
                                        ? "login-background-color-white"
                                        : "recover-pass-desktop recover-pass-desktop-token"
                                }
                                centerElement={!isDesktop && this.renderTitleMobile}
                                hideMobileMenu={!isDesktop && true}
                                fixed
                            />
                        </Col>
                    </Container>
                </div>
                <MainContainer
                    className={classNames("login__layout main-container", {
                        "container-fluid": isDesktop,
                    })}>
                    {!isDesktop && (
                        <Container className="container--layout flex-grow">
                            <Col className="col col-12 view-title mt-3">
                                <div className="justify-content-center">
                                    <I18n
                                        id="recoveryUserpass.step3.header"
                                        componentProps={{ className: "f-size-5 font-regular" }}
                                        component="h2"
                                    />
                                </div>
                            </Col>
                        </Container>
                    )}
                    <Step3Content {...this.props} isRecoveringUserpass={isRecoveringUserpass} />
                </MainContainer>
            </GridLayoutExternal>
        );
    }
}

RecoveryUserpassStep3.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool,
    isRecoveringUserpass: bool,
    propsGrid: shape({}).isRequired,
    exchangeToken: string.isRequired,
};

RecoveryUserpassStep3.defaultProps = {
    isDesktop: true,
    isRecoveringUserpass: true,
};

const mapStateToProps = (state) => ({
    exchangeToken: recoveryPasswordSelectors.getExchangeToken(state),
    resetCode: recoveryPasswordSelectors.getResetCode(state),
});

export default connect(mapStateToProps)(withExchangeToken(RecoveryUserpassStep3));
